import { render, staticRenderFns } from "./NotAvailable.vue?vue&type=template&id=c9a30bde&"
import script from "./NotAvailable.vue?vue&type=script&lang=ts&"
export * from "./NotAvailable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports